import React from 'react';
import Icon from '../../../components/AppIcon';

const MoodHistory = ({ historyData }) => {
  const moodHistory = [];

  const getEnergyBars = (level) => {
    return Array.from({ length: 5 }, (_, i) => (
      <div
        key={i}
        className={`h-1 rounded-full ${
          i < level ? 'bg-primary' : 'bg-muted'
        }`}
      />
    ));
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Recent Mood History
        </h3>
        <button className="text-sm text-primary hover:text-primary/80 transition-therapeutic font-medium">
          View All
        </button>
      </div>
      <div className="space-y-3">
        {moodHistory?.map((entry) => (
          <div
            key={entry?.id}
            className="flex items-start space-x-3 p-4 rounded-md bg-card border border-border"
          >
            <div className="flex items-center justify-center w-10 h-10 rounded-md bg-muted flex-shrink-0">
              <Icon name={entry?.icon} size={20} color={entry?.color} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-medium text-foreground">
                  {entry?.moodLabel}
                </span>
                <span className="text-xs text-muted-foreground whitespace-nowrap">
                  {entry?.date}
                </span>
              </div>
              <div className="flex items-center space-x-2 mb-2">
                <span className="text-xs text-muted-foreground">
                  {entry?.time}
                </span>
                <span className="text-xs text-muted-foreground">•</span>
                <div className="flex items-center space-x-1">
                  <Icon name="Zap" size={12} color="var(--color-muted-foreground)" />
                  <span className="text-xs text-muted-foreground">
                    Energy: {entry?.energy}/5
                  </span>
                </div>
              </div>
              <div className="grid grid-cols-5 gap-1 mb-2">
                {getEnergyBars(entry?.energy)}
              </div>
              <div className="flex flex-wrap gap-1">
                {entry?.types?.map((type) => (
                  <span
                    key={type}
                    className="px-2 py-0.5 text-xs rounded-md bg-primary/10 text-primary capitalize"
                  >
                    {type}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MoodHistory;